export default __webpack_public_path__ + "static/position-98e3ab01cbbc0c3e0a527fc97b4aa11e.png";